import { render, staticRenderFns } from "./CalculateProductPart.vue?vue&type=template&id=48b7b40e"
import script from "./CalculateProductPart.vue?vue&type=script&lang=js"
export * from "./CalculateProductPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports